import React, { FC, MouseEvent } from 'react';
import { Button, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const styles = {
  root: {
    position: 'relative',
    backgroundColor: 'common.white',
    padding: '10px 8px 10px 14px',
    marginBottom: 2,
    borderTopRightRadius: 18,
    borderBottomRightRadius: 18,
    borderLeftColor: 'primary.main',
    borderLeft: '4px solid',
    width: '100%',
    '&:hover': {
      backgroundColor: 'common.white',
    },
  },

  endIcon: {
    position: 'absolute',
    right: 20,
    cursor: 'pointer',
  },
} as const;

interface Props {
  label: string;
  onClick: () => void;
  onClose: () => void;
}

const SetupButton: FC<Props> = ({ label, onClick, onClose }) => {
  function handleClose(event: MouseEvent) {
    event.stopPropagation();
    onClose();
  }

  return (
    <Button
      onClick={onClick}
      endIcon={<CloseIcon onClick={handleClose} color="disabled" />}
      sx={{ root: styles.root, endIcon: styles.endIcon }}
    >
      <Typography color="textPrimary" variant="body2">
        {label}
      </Typography>
    </Button>
  );
};

export default SetupButton;
